import { getBackendBaseUrl } from './config';
import { getAuthHeaders } from './auth';

export interface AccountingProfile {
  id: number;
  name: string;
  username: string;
  email: string;
  mobile: string | null;
  mobile_national?: string | null;
}

function getApiBase(): string {
  const base = getBackendBaseUrl();
  return base ? `${base}/api` : '/api';
}

async function parseJson(r: Response): Promise<unknown> {
  const t = await r.text();
  if (!t?.trim()) return {};
  try {
    return JSON.parse(t) as unknown;
  } catch {
    return {};
  }
}

function pickMessage(json: unknown, fallback: string): string {
  if (!json || typeof json !== 'object') return fallback;
  const j = json as Record<string, unknown>;
  if (typeof j.message === 'string' && j.message.trim()) return j.message;
  return fallback;
}

export const accountingProfileApi = {
  async fetch(): Promise<AccountingProfile> {
    const r = await fetch(`${getApiBase()}/task-manager/me`, {
      headers: getAuthHeaders(),
    });
    const json = await parseJson(r);
    const data = (json as { data?: AccountingProfile }).data;
    if (!r.ok || !data) throw new Error(pickMessage(json, `خطا: ${r.status}`));
    return data;
  },

  async requestMobileOtp(mobileNational: string): Promise<{ alreadySet?: boolean; message?: string }> {
    const r = await fetch(`${getApiBase()}/task-manager/me/mobile/request-otp`, {
      method: 'POST',
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json',
      } as HeadersInit,
      body: JSON.stringify({ mobile_national: mobileNational }),
    });
    const json = (await parseJson(r)) as {
      message?: string;
      data?: { already_set?: boolean };
    };
    if (!r.ok) throw new Error(pickMessage(json, `خطا: ${r.status}`));
    return {
      alreadySet: Boolean(json.data?.already_set),
      message: json.message,
    };
  },

  async verifyMobileOtp(code: string): Promise<AccountingProfile> {
    const r = await fetch(`${getApiBase()}/task-manager/me/mobile/verify`, {
      method: 'POST',
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json',
      } as HeadersInit,
      body: JSON.stringify({ code: code.replace(/\D/g, '').slice(0, 5) }),
    });
    const json = await parseJson(r);
    const data = (json as { data?: AccountingProfile }).data;
    if (!r.ok || !data) throw new Error(pickMessage(json, `خطا: ${r.status}`));
    return data;
  },
};
